import { render, staticRenderFns } from "./SpirometryMeasurements.vue?vue&type=template&id=76353723&scoped=true"
import script from "./SpirometryMeasurements.vue?vue&type=script&lang=js"
export * from "./SpirometryMeasurements.vue?vue&type=script&lang=js"
import style0 from "./SpirometryMeasurements.vue?vue&type=style&index=0&id=76353723&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76353723",
  null
  
)

export default component.exports